let _root = null

export function setCarvueRoot(el) {
	_root = el || null
}

export function getCarvueRoot() {
	return _root
}

export function cvQuery(sel) {
	if (!_root) return document.querySelector(sel)
	if (sel.charAt(0) === '#') return _root.querySelector(sel)
	if (sel.charAt(0) === '.') return _root.querySelector(sel)
	return _root.querySelector(sel)
}

export function cvQueryAll(sel) {
	if (!_root) return document.querySelectorAll(sel)
	return _root.querySelectorAll(sel)
}
